import { useEffect, useState } from "react";
import api, { money } from "@/lib/api";
import { TrendingUp, TrendingDown } from "lucide-react";

export default function RollingForecast() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/targets/rolling-forecast").then(r => setData(r.data)).catch(() => {}); }, []);
  if (!data || !data.rows) return null;
  return (
    <div className="bg-white rounded-xl border border-slate-200 p-5" data-testid="rolling-forecast-card">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-lg font-heading font-semibold text-[#001F54]">3-Month Rolling Forecast</h3>
          <p className="text-xs text-slate-500 mt-0.5">Based on trailing 3-month average sales — spot slowdowns before month-end.</p>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-xs uppercase text-slate-500 border-b">
            <tr>
              <th className="text-left py-2 pr-3">Agent</th>
              <th className="text-right px-3">Avg / Month</th>
              {data.rows[0]?.forecast?.map(f => <th key={f.month} className="text-right px-3">{f.month}</th>)}
              <th className="text-right pl-3">Current Target</th>
              <th className="text-right pl-3">Gap vs Target</th>
            </tr>
          </thead>
          <tbody>
            {data.rows.map(r => (
              <tr key={r.agent_id} className="border-b border-slate-100" data-testid={`forecast-row-${r.agent_id}`}>
                <td className="py-2 pr-3 font-semibold text-[#001F54]">{r.agent_name}</td>
                <td className="px-3 text-right font-semibold">{money(r.avg_month)}</td>
                {r.forecast.map(f => <td key={f.month} className="px-3 text-right text-slate-700">{money(f.forecast)}</td>)}
                <td className="pl-3 text-right">{r.current_target != null ? money(r.current_target) : "—"}</td>
                <td className={`pl-3 text-right font-semibold ${r.gap_vs_target == null ? "text-slate-400" : r.gap_vs_target >= 0 ? "text-emerald-600" : "text-red-600"}`}>
                  {r.gap_vs_target == null ? "—" : (
                    <span className="inline-flex items-center gap-1">
                      {r.gap_vs_target >= 0 ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
                      {r.gap_vs_target >= 0 ? "+" : ""}{money(r.gap_vs_target)}
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
